import React from "react";
import swal from 'sweetalert';

import Server from "../../../services/Server";

import View from "./view";
import New from "./New";

const GlobalEntryName = "Wowza-CDN";

const Restreaming = ({ firebase, event, maxRestreaming, transcoder})=>{
    
    const [isLoading, setLoadingStatus] = React.useState(true);
    const [hasError, setErrorStatus] = React.useState(false);
    const [isConnected, setConnectedStatus] = React.useState(false);

    const [currentRecord, setCurrentRecord] = React.useState({});
    const [targets, setTargets] = React.useState([]);
    const [targetsCount, setTargetsCount] = React.useState(0);
    const [CurrentView, setCurrentView] = React.useState('list');

    const 
        { id, videoServer, live_stream = {} } = event,
        transcoderId = live_stream.id;

    React.useEffect(()=>{
        const
            _targets = [];
            
        Server.events.getStreamTargets(videoServer, id)
        .then((answer)=>{

            const { PushPublishStreams = {}} = answer.data,
                { MapEntries = false} = PushPublishStreams;

            if (MapEntries !== false){
                if (Array.isArray(MapEntries)){
                    MapEntries.forEach((entry)=>{
                        if (entry.EntryName === GlobalEntryName){
                            _targets.push({ id: GlobalEntryName, ...entry });
                        }
                    });
                } else {
                    try {
                        if (MapEntries.EntryName === GlobalEntryName){
                            _targets.push({ id: GlobalEntryName, ...MapEntries, status: 'loading' });
                        }
                    } catch(errr) {

                    }
                }
            }

            getRecords({ firebase, id, _targets, setTargets, setLoadingStatus, videoServer, transcoderId, setConnectedStatus, setTargetsCount});
            
        })
        .catch(()=>{
            setErrorStatus(true);
            setLoadingStatus(false);
        });
        
    }, [event, firebase, id, transcoderId, videoServer]);


    const onDoubleClick = ({rowId})=>{
        for (let idx = 0; idx < targets.length; idx++){
            if (targets[idx].id === rowId){
                setCurrentRecord(targets[idx]);
                setCurrentView('update');
            }
        }
    }

    

    const onRegenerateConnectionCode = ()=> {
        setLoadingStatus(true);
        Server.events.regenerateConnectionCode(videoServer, id, transcoder)
        .then((data)=>{
            swal({
                title: "",
                text: `El código ha sido actualizado`,
                icon: "success",
                buttons: false,
                dangerMode: false
            });
            setLoadingStatus(false);
        })
        .catch(() => {
            swal({
                title: "",
                text: `Hubo un error, por favor intenta nuevamente`,
                icon: "warning",
                buttons: true,
                dangerMode: true
            })
            setLoadingStatus(false);
        });
    }

    const onDeleteRecord = ({ streamTargetId, outputId, idRecord})=>{
        swal({
            title: "¿Eliminar destino?",
            text: "Se eliminará este destino de retransmisión y será irreversible. ¿Estás seguro?",
            icon: "warning",
            buttons: ["Cancelar", "Eliminar"],
            dangerMode: true
        })
            .then((willDelete) => {
                if (willDelete) {
                    setLoadingStatus(true);
                    Server.deleteStreamTarget(videoServer, transcoderId, {streamTargetId, outputId, eventId : id})
                    .then((response)=>{
                        console.log("✅ Stream target eliminado de Wowza:", response.data);
                        
                        // Eliminar de Firestore
                        firebase.subCollection.delete("events", id, "stream_targets", idRecord)
                        .then(()=>{
                            // Actualizar la lista local removiendo el target eliminado
                            setTargets(prevTargets => prevTargets.filter(t => t.idRecord !== idRecord));
                            setTargetsCount(prev => Math.max(0, prev - 1));
                            setLoadingStatus(false);
                            
                            // Mostrar mensaje de éxito
                            if (response.data?.warning) {
                                swal("Eliminado", "El destino ha sido eliminado de la base de datos. " + response.data.warning, "warning");
                            } else {
                                swal("Eliminado", "El destino de retransmisión ha sido eliminado exitosamente.", "success");
                            }
                        })
                        .catch((error)=>{
                            console.error("Error eliminando de Firestore:", error);
                            setLoadingStatus(false);
                            swal("Error", "No se pudo eliminar de la base de datos.", "error");
                        });
                    })
                    .catch((error)=>{
                        console.error("Error eliminando stream target:", error);
                        swal("Error", "En este momento no es posible eliminar el destino. Por favor, inténtalo de nuevo.", "error")
                        .then(()=>{
                            setLoadingStatus(false);
                        });
                    })
                }
            });
    }

    const onTurnStatus = ({stream_target_id, new_status})=>{
        
        const new_status_text = (new_status === 'disable' ? 'Desactivar' : 'Activar');
        const consecuence_text = (new_status === 'disable' ? 'detendrá' : 'iniciará');
        
        swal({
            title: "",
            text: `¿Estas seguro que quieres ${new_status_text} este destino de transmisión? Esto ${consecuence_text} la entrega de datos de transmisión al destino de destino de transmisión.`,
            icon: "warning",
            buttons: true,
            dangerMode: true
        })
            .then((willChange) => {
                if (willChange) {
                    
                    setLoadingStatus(true);
                    Server.events.streamTargetTurnStatus(videoServer, id, stream_target_id, new_status, transcoderId)
                        .then((response) => {
                            setLoadingStatus(false);
                            const d = new Date();
                            onGetStreamTargetsStatus({ videoServer, id, transcoderId, targets, setConnectedStatus, setTargets, verification_code: d.getTime() })
                        })
                        .catch((error) => {
                            try{
                                if(error.response.status === 422){
                                    swal("Error", "No es posible manipular los destinos de transmisión mientras el Stream está detenido", "error")
                                        .then(() => {
                                            setLoadingStatus(false);
                                        });
                                } else{
                                    swal("Error", "En este momento no es posible validar tu solicitud, por favor intentalo de nuevo en unos momentos", "error")
                                        .then(() => {
                                            setLoadingStatus(false);
                                        });
                                }
                                
                            } catch(error){
                                swal("Error", "En este momento no es posible validar tu solicitud, por favor intentalo de nuevo en unos momentos", "error")
                                    .then(() => {
                                        setLoadingStatus(false);
                                    });
                            }
                        })
                }
            });
    }

    
    if (isLoading){
        return (
            <div className="cntEventLoading">
                <img src={`${process.env.PUBLIC_URL}/assets/images/loading3.gif`} alt="loading" />
            </div>
        );    
    }

    if (hasError) {
        return (
            <div className="alert alert-danger mg-t-30 tx-center">
                <span>En este momento no es posible procesar tu solicitud, te recomendamos esperar unos momentos y reintentar ésta tarea</span>
            </div>
        );
    }

    if (CurrentView.substr(0, 3) === "new"){
        let custom_type = '';
        if (CurrentView.length > 3){
            custom_type = CurrentView.split("_")[1];
        }
        return (
            <New
                setCurrentView={setCurrentView} 
                firebase={firebase}
                id={id}
                custom_type={custom_type}
                transcoderId={transcoderId}
                videoServer={videoServer}
                setTargets={setTargets} />
        )
    }

    if (CurrentView === "update") {
        return (
            <New
                update
                record={currentRecord}
                custom_type={currentRecord.type || ''}
                setCurrentView={setCurrentView}
                firebase={firebase}
                id={id}
                transcoderId={transcoderId}
                videoServer={videoServer}
                setTargets={setTargets} />
        )
    }

    return (
        <View 
            list={targets}
            isConnected={isConnected}
            onTurnStatus={onTurnStatus}
            onRegenerateConnectionCode={onRegenerateConnectionCode}
            maxRestreaming={maxRestreaming}
            targetsCount={targetsCount}
            onDeleteRecord={onDeleteRecord}
            setCurrentView={setCurrentView}
            onDoubleClick={onDoubleClick}
        />
    )
}

export default Restreaming;

const getRecords = ({ firebase, id, _targets, setTargets, setLoadingStatus, videoServer, transcoderId, setConnectedStatus, setTargetsCount})=>{
    firebase.getCollectionBySocket("events", id, "stream_targets", {
        condition_field: "timestamp",
        condition: ">=",
        condition_value: 0
    }, (data) => {
        const __targets = [..._targets];
        let _targetsCount = 0;
        data.docs.forEach((doc) => {
            const _data = doc.data();
            const _streamTargetId = _data.output_stream_target.stream_target.id;
            __targets.push({ id: _streamTargetId, idRecord: doc.id, ..._data, status: 'loading' });
            if (_streamTargetId !== 'Wowza-CDN'){
                _targetsCount++;
            }
        });
        setTargets([...__targets]);
        setTargetsCount(_targetsCount);
        setLoadingStatus(false);

        const d = new Date();

            onGetStreamTargetsStatus({ videoServer, id, transcoderId, targets: __targets, setConnectedStatus, setTargets, verification_code : d.getTime()})
    });
}

const getStreamTargetsStatus = ({ videoServer, id, transcoderId, targets, setConnectedStatus}) => {
    return new Promise((resolve, reject)=>{
        if (targets.length > 0) {
            Server.events.getStreamTargetsStatus(videoServer, transcoderId, id)
                .then((response) => {
                    const 
                        {data = {}} = response,
                        {connected = {value : 'No'}} = data;

                    setConnectedStatus(connected.value === 'Yes');
                    const { stream_targets = [] } = response.data;
                    const newTarget = [];

                    targets.forEach((_target)=>{
                        const obj = stream_targets.filter(_st => _st.id === _target.id);
                        
                        if (obj.length > 0){
                            _target.status = obj[0].status;
                            _target.enable = obj[0].enabled;
                        } else{
                            _target.status = 'Unknown';
                            _target.enable = false;
                        }
                        newTarget.push(_target);
                    });
                    resolve(newTarget);
                })
                .catch(reject);
        } else{
            resolve([]);
        }
    });
}

let isTimeOutActive = 0;

const onGetStreamTargetsStatus = ({ videoServer, id, transcoderId, targets, setConnectedStatus, setTargets, verification_code }) => {
    getStreamTargetsStatus({ videoServer, id, transcoderId, targets, setConnectedStatus })
    .then((newTargets) => {
        if (newTargets.length > 0) {
            setTargets(newTargets);
        }

        if (verification_code >= isTimeOutActive){
            isTimeOutActive = verification_code;
    
            setTimeout(() => {
                onGetStreamTargetsStatus({ videoServer, id, transcoderId, targets, setConnectedStatus, setTargets, verification_code });
            }, 30000);
        }
    });
}